import { apiRequest } from './api';
import { uiLanguage } from './language';
import type { MeetingShareAccess, MeetingShareDTO } from '../shared/types';

/**
 * Toplantı ve klasör paylaşımı: yalnızca davet edilen kişilerle ya da bağlantıya sahip herkesle.
 * Sunucu ucu: web/lib/sharing/routes.ts. Web ve mobil aynı modülü kullanır.
 */

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function shareClient(kind: 'meeting' | 'folder') {
  const path = (id: string): string => {
    if (!UUID.test(id)) throw new Error('Geçersiz kayıt.');
    return `/api/v1/${kind === 'folder' ? 'folders' : 'meetings'}/${id}/share`;
  };
  return {
    get: (id: string) => apiRequest<MeetingShareDTO>('GET', path(id)),
    setAccess: (id: string, access: MeetingShareAccess) => apiRequest<MeetingShareDTO>('PATCH', path(id), { body: { access } }),
    addRecipients: (id: string, emails: string[]) => apiRequest<MeetingShareDTO>('POST', path(id), { body: { emails, language: uiLanguage() } }),
    removeRecipient: (id: string, recipientId: string) =>
      apiRequest<MeetingShareDTO>('DELETE', `${path(id)}?recipient=${encodeURIComponent(recipientId)}`),
  };
}
